import * as F from "fp-ts/function"
import * as E from "fp-ts/Either"
import { Either } from "fp-ts/Either"
import { Type } from "io-ts"
import * as GenericError from "./generic-error"
import * as Schema from "effect/Schema"
import * as SchemaAST from "effect/SchemaAST"
import * as EitherEffect from "effect/Either"
import * as EitherAdapter from "@silversea-ssc/fp-ts-to-effect/EitherAdapter"
import * as O from "effect/Option"

type Decoder<T> = (a: unknown) => Either<GenericError.GenericError, T>
export const decode = <T>(type: Type<T, unknown>): Decoder<T> =>
    F.flow(type.decode, E.mapLeft(GenericError.fromValidation(`Unable to decode ${type.name}`)))

export const decodeSchema = <A, I>(schema: Schema.Schema<A, I, never>) => {
    const decode = Schema.decodeUnknownEither(schema)
    return (i: unknown) =>
        decode(i).pipe(
            EitherEffect.mapLeft(GenericError.fromParseError(`Unable to decode ${getIdentifier(schema.ast)}`)),
        )
}

const getIdentifier = F.flow(
    SchemaAST.getAnnotation(SchemaAST.IdentifierAnnotationId),
    O.getOrElse(() => "Unknown identifier"),
)

export const decodeEffect = <T>(type: Type<T, unknown>) => EitherAdapter.toEffectK(decode(type))
